import React from 'react'
import { Panel, Card } from '../../../_components'
import { useDispatch, useSelector } from 'react-redux'
import { setDisplayModal, removePurchaseSeeds } from '../../../_slices/AppSlice'
import { formatCurrency } from '../../../_utils'

export default function SectionB() {
  const dispatch = useDispatch()
  const state = useSelector( state => {
    return {
      title: state.application.displayModal?.title,
      flag: state.application.displayModal?.flag,
      labor: state.application.labor
    }
  } )

  const handleDeleteItem = async ( idx ) => {
    await dispatch( removePurchaseSeeds( { idx } ) )
  }

  const handleAdd = async ( tag, slug ) => {
    dispatch( setDisplayModal( { flag: true, title: slug, tag } ) )
  }

  const handleCalculateFooter = ( tag ) => {
    if( state[ tag ].length > 0 ) {
     return state[tag].filter( item => { 
        return parseFloat( item.qty ) > 0 && parseFloat( item.rate ) > 0 
      } )
      .map( val => parseFloat( val.amount ) )
      .reduce( ( acc, curr ) => {
        return acc + curr 
      }, 0 )
    }
  }

  return (
    <Card title="Labor">
        <Panel label="Section C: Labor( Monetary terms)">
        <div className="grid grid-cols-1">
            <table className="w-full border">
              <thead className="text-xs bg-gray-200 font-bold p-2 uppercase">
                  <th className="p-2 text-start">Actions</th>
                  <th className="text-start">{`Item`}</th>
                  <th className="text-start">{`Quantity`}</th>
                  <th className="text-start">{`Rate`}</th>
                  <th className="text-start">{`Amount(UGX)`}</th>
              </thead>
              <tbody>
                  {[
                    { name: "1st Plouging", slug: "ploughing1", tag: "labor" },
                    { name: "2nd Ploughing", slug: "ploughing2", tag: "labor" },
                    { name: "Creating Bands", slug: "bands", tag: "labor" },
                    { name: "Levelling", slug: "levelling", tag: "labor" },
                    { name: "Nursery Bed Preparation", slug: "nursery", tag: "labor" },
                    { name: "Paddling and Transplanting", slug: "transplanting", tag: "labor" },
                    { name: "Weeding", slug: "weeding", tag: "labor" },
                    { name: "Fertilizer Application", slug: "fertilizer", tag: "labor" },
                    { name: "Herbicides", slug: "herbicides", tag: "labor" },
                    { name: "Bird Scaring", slug: "bird scaring", tag: "labor" },
                    { name: "Control of Rodents", slug: "rodents control", tag: "labor" },
                    { name: "Others(Specify)", slug: "other", tag: "labor" }
                  ].map( ( val, index ) => {
                      return (
                      <tr className="text-xs p-2 text-start border border-gray-300">
                          <td className="p-2 flex">
                            <button onClick={ () => handleAdd( val.tag, val.slug ) } className="rounded bg-purple-700 px-2 text-white" type="button">
                              {`+`}
                            </button>
                          </td>
                          <td>{val.name}</td>
                          <td>{state.labor.length > 0 && state.labor.filter( item => item.title === val.slug )[ 0 ]?.qty}</td>
                          <td>{state.labor.length > 0 && state.labor.filter( item => item.title === val.slug )[ 0 ]?.rate}</td>
                          <td>{state.labor.length > 0 && state.labor.filter( item => item.title === val.slug )[ 0 ]?.amount}</td>
                      </tr>
                      )
                  } )}
              </tbody>
              <tfoot className="bg-gray-400 text-xs uppercase font-bold text-start">
                <td></td>
                <td>{`Total`}</td>
                <td></td>
                <td></td>
                <td>{handleCalculateFooter("labor")}</td>
              </tfoot>
            </table>
        </div>
      </Panel>
    </Card>
  )
}
